<template>
  <div >
    <el-tabs v-model="country" @tab-click="handleClick">
      <el-tab-pane label="美国" name="1"></el-tab-pane>
      <el-tab-pane label="加拿大" name="2"></el-tab-pane>
    </el-tabs>
    <keep-alive>
        <components
            :is="currentComponent"
            :country="country">
        </components>
    </keep-alive>
  </div>
</template>

<script>
import commodityMgmt from '@v/commodityMgmt/commodityMgmt.vue'
export default {
    data () {
        return {
            country: '1',
            currentComponent: 'commodityMgmt1',
            componentList: [
                'commodityMgmt1',
                'commodityMgmt2'
            ]
        }
    },
    components: {
        commodityMgmt1: commodityMgmt,
        commodityMgmt2: commodityMgmt
    },
    methods: {
        handleClick (e) {
            console.log(this);
            this.currentComponent = this.componentList[this.country - 0 - 1];
        }
    }
}
</script>

<style>
  .el-tabs__nav-scroll{
    padding-left: 15px;
  }
</style>
